<template>
    <div class="main">
        <c-panel title="VÍNCULO DE IRMÃOS" titleIcon="fas fa-users">
            <div style="color: #909399; font-size: 12px; margin-bottom: 15px;">
                Associe irmãos para facilitar matrículas em conjunto, filtros familiares e relatórios de fluxo escolar. O vínculo é <strong>bidirecional</strong> (ao adicionar A→B, também grava B→A).
            </div>

            <el-form label-position="top">
                <el-form-item label="Aluno principal">
                    <el-select v-model="alunoSelecionadoId"
                               filterable remote :remote-method="searchAluno"
                               :loading="loadingAluno" clearable
                               placeholder="Digite o nome do aluno..."
                               @change="onAlunoChange">
                        <el-option v-for="a in alunos" :key="a.id" :label="a.nome + (a.num_matricula ? ' — ' + a.num_matricula : '')" :value="a.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div v-if="alunoSelecionadoId">
                <h4 style="margin-top: 20px; color: #303133;">Irmãos vinculados</h4>

                <div class="container-table" v-if="irmaos.length">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th style="width: 130px;">Data nascimento</th>
                                <th style="width: 110px;">INEP</th>
                                <th style="width: 110px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="irmao in irmaos" :key="irmao.vinculo_id">
                                <td>{{ irmao.nome }}</td>
                                <td>{{ formatData(irmao.data_nascimento) }}</td>
                                <td>{{ irmao.inep || '—' }}</td>
                                <td class="u-text-center">
                                    <el-button @click="desassociar(irmao.irmao_id)" type="danger" size="mini" plain>
                                        <i class="el-icon-delete"></i> Desvincular
                                    </el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else style="padding: 20px; text-align: center; color: #909399; background: #f5f7fa; border-radius: 4px;">
                    Nenhum irmão vinculado ainda.
                </div>

                <c-panel title="Adicionar novo irmão" titleIcon="fas fa-plus-circle" style="margin-top: 20px;">
                    <el-form label-position="top" :inline="true">
                        <el-form-item label="Buscar aluno para vincular como irmão">
                            <el-select v-model="novoIrmaoId"
                                       filterable remote :remote-method="searchAluno"
                                       :loading="loadingAluno" clearable
                                       placeholder="Digite o nome do aluno..."
                                       style="width: 400px;">
                                <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id" :disabled="a.id === alunoSelecionadoId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label=" ">
                            <el-button @click="associar" type="primary" :disabled="!novoIrmaoId">
                                <i class="el-icon-plus"></i> VINCULAR
                            </el-button>
                        </el-form-item>
                    </el-form>
                </c-panel>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        loadingAluno: false,
        alunos: [],
        alunoSelecionadoId: null,
        novoIrmaoId: null,
        irmaos: []
    }),
    methods: {
        searchAluno (query) {
            if (!query) { this.alunos = []; return }
            this.loadingAluno = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.alunos = r.data || [] })
              .catch(() => {})
              .finally(() => { this.loadingAluno = false })
        },
        onAlunoChange () {
            this.novoIrmaoId = null
            if (this.alunoSelecionadoId) {
                this.carregarIrmaos()
            }
        },
        carregarIrmaos () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/aluno-irmao/listarPorAluno/${this.alunoSelecionadoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.irmaos = r.data || [] })
              .catch(e => this.$store.commit('throwException', e))
        },
        associar () {
            if (!this.novoIrmaoId) return
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno-irmao/associar`,
                { aluno_id: this.alunoSelecionadoId, irmao_id: this.novoIrmaoId },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Irmão vinculado.', type: 'success' })
                this.novoIrmaoId = null
                this.carregarIrmaos()
            }).catch(e => this.$store.commit('throwException', e))
        },
        desassociar (irmaoId) {
            this.$msgbox.confirm('Desvincular este irmão?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/aluno-irmao/desassociar`,
                    { aluno_id: this.alunoSelecionadoId, irmao_id: irmaoId },
                    this.$store.getters.getHeaderAuth
                ).then(() => {
                    window.eventBus.$emit('alert', { msg: 'Vínculo removido.', type: 'success' })
                    this.carregarIrmaos()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        formatData (data) {
            if (!data) return '—'
            return this.$moment(data).format('DD/MM/YYYY')
        }
    }
}
</script>
